var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Cursos"}},[_c('b-card-text',[_vm._v("Confira os cursos que preparamos para você!")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.openEad}},[_vm._v("Acessar o EAD")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }